import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-template-priority-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class TemplatePriorityLoaderComponent {

}
